import {
  getCoreRowModel,
  getFilteredRowModel,
  useReactTable
} from '@tanstack/react-table'
import { Table as TableCortex } from '@tecsinapse/cortex-react'
import React, { useEffect } from 'react'
import { Table } from '@/core/components/index'
import { Funcionalidade } from '@/core/types/graphql'
import { columns } from '../columns'

interface TabelaFuncionalidadeProps {
  data: Funcionalidade[]
  updateSelectedFuncionalidades: any
  removeFuncionalidade: any
  addFuncionalidade: any
  selectedFuncionalidades: Funcionalidade[]
  tourId?: string
}

export const TabelaFuncionalidades = ({
  data,
  updateSelectedFuncionalidades,
  addFuncionalidade,
  removeFuncionalidade,
  selectedFuncionalidades,
  tourId
}: TabelaFuncionalidadeProps) => {
  const [rowSelection, setRowSelection] = React.useState({})

  const table = useReactTable({
    data: data ?? [],
    columns: columns(
      updateSelectedFuncionalidades,
      addFuncionalidade,
      removeFuncionalidade
    ),
    getCoreRowModel: getCoreRowModel(),
    rowCount: data?.length,
    getFilteredRowModel: getFilteredRowModel(),
    enableRowSelection: true,
    getRowId: originalRow => originalRow.id,
    state: {
      rowSelection
    },
    onRowSelectionChange: setRowSelection
  })

  useEffect(() => {
    const selected = selectedFuncionalidades.map(func => func?.id)
    const initialSelection = (data ?? []).reduce((acc, row) => {
      return {
        ...acc,
        [row.id]: selected.includes(row.id)
      }
    }, {})
    setRowSelection(initialSelection)
  }, [selectedFuncionalidades, data, table])

  return (
    <TableCortex className={'w-full'}>
      <Table.HeaderColumns table={table} />
      <Table.Body table={table} id={`${tourId}-table`} />
    </TableCortex>
  )
}
